export const removeLeadingAndTrailingCommas = (str: string): string => {
  return str.trim().replace(/^,+|,+$/g, '');
};
